import _extends from "@babel/runtime/helpers/extends";

/** @jsx jsx */
import { jsx } from '@emotion/core';
import { defaultAttributesFn } from '../utils';
export var labelTextCSS = function labelTextCSS(_ref) {
  var tokens = _ref.tokens;
  return {
    paddingTop: tokens.label.spacing.top,
    paddingRight: tokens.label.spacing.right,
    paddingBottom: tokens.label.spacing.bottom,
    paddingLeft: tokens.label.spacing.left
  };
};
export function LabelText(_ref2) {
  var attributesFn = _ref2.attributesFn,
      tokens = _ref2.tokens,
      children = _ref2.children,
      cssFn = _ref2.cssFn;
  return jsx("span", _extends({}, attributesFn(), {
    css: cssFn({
      tokens: tokens
    })
  }), children);
}
export default {
  component: LabelText,
  cssFn: labelTextCSS,
  attributesFn: defaultAttributesFn
};